import {useQuery} from '@tanstack/react-query';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {apiClient} from '@common/http/query-client';
import { LoanProduct } from '@app_modules/loan-products/loan-product';
import { LoanProgram } from '@app_modules/loan-products/loan-program/loan-program';

export interface FetchRoleResponse extends BackendResponse {
   programs: LoanProgram[];
}

export function useMyLoanPrograms() {
  return useQuery({
    queryKey: ['my-loan-programs'],
    queryFn: () => fetchLoanPrograms(),
  });
}

function fetchLoanPrograms(): Promise<FetchRoleResponse> {
  return apiClient.get('my-loan-programs').then(response => response.data);
}
